import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import { createAsyncAction, findCategory, findMenuEntry, findAndReplace } from '@smorder/logic';

const INITIAL_STATE = Immutable({
  productDialogOpen: false,
  menus: [],
  isLoadingMenus: false,
  isLoadingProducts: false,
  products: [],
  productionPlaces: [],
  isLoadingProductionPlaces: false,
});

export const toggleProductDialog = createAction('toggleProductDialog');
export const loadMenuTreeAction = createAsyncAction('loadMenuTree');

export const updateMenuAction = createAsyncAction('updateMenu');
export const updateCategoryAction = createAsyncAction('updateCategory');
export const updateMenuEntryAction = createAsyncAction('updateMenuEntry');

export const loadProductsAction = createAsyncAction('loadProducts');
export const updateProductAction = createAsyncAction('updateProduct');

export const updateMenusAction = createAsyncAction('updateMenus');
export const updateCategoriesAction = createAsyncAction('updateCategories');
export const updateMenuEntriesAction = createAsyncAction('updateMenuEntries');
export const updateProductsAction = createAsyncAction('updateProducts');

export const loadProductionPlacesAction = createAsyncAction('loadProductionPlaces');

const notEmpty = value => value !== null && value !== undefined;

const updateCategory = (oldMenus, category) => {
  const { menu } = findCategory(oldMenus, category.id);
  const categories = findAndReplace([...menu.categories], category);
  menu.categories = categories;
  const menus = findAndReplace([...oldMenus], menu);
  return menus;
};

const updateMenuEntry = (oldMenus, menuEntry) => {
  const { menu, category } = findMenuEntry(oldMenus, menuEntry.id);

  const menuEntries = findAndReplace([...category.menuEntries], menuEntry);
  category.menuEntries = menuEntries;

  const categories = findAndReplace([...menu.categories], category);
  menu.categories = categories;

  const menus = findAndReplace([...oldMenus], menu);

  return menus;
};

const updateMenus = (state, menuIds, data) => {
  let menus = [...state.menus];

  menuIds.forEach((menuId) => {
    const oldMenu = menus.find(m => m.id === menuId);
    const newMenu = {
      ...oldMenu,
      visibleInApp: notEmpty(data.visible) ? data.visible : oldMenu.visibleInApp,
      orderable: notEmpty(data.orderable) ? data.orderable : oldMenu.orderable,
    };
    menus = findAndReplace(menus, newMenu);
  });

  return menus;
};

const updateCategories = (state, categoryIds, data) => {
  let menus = [...state.menus];

  categoryIds.forEach((categoryId) => {
    const { category } = findCategory(menus, categoryId);
    const newCategory = {
      ...category,
      ...data,
    };
    menus = updateCategory(menus, newCategory);
  });

  return menus;
};

const updateMenuEntries = (state, menuEntryIds, data) => {
  let menus = [...state.menus];

  menuEntryIds.forEach((menuEntryId) => {
    const { menuEntry } = findMenuEntry(menus, menuEntryId);
    const newMenuEntry = {
      ...menuEntry,
      ...data,
    };
    menus = updateMenuEntry(menus, newMenuEntry);
  });

  return menus;
};

const updateProducts = (state, productIds, data) => {
  let products = [...state.products];

  productIds.forEach((productId) => {
    const product = products.find(p => p.productID === productId);
    const newProduct = {
      ...product,
      isLocked: notEmpty(data.orderable) ? !data.orderable : product.isLocked,
      isVisible: notEmpty(data.visible) ? data.visible : product.isVisible,
    };
    products = findAndReplace(products, newProduct, 'productID');
  });

  return products;
};

const reducers = createReducer({
  [toggleProductDialog]: (state, productDialogOpen) => state.merge({ productDialogOpen }),
  [loadMenuTreeAction.INIT]: state => state.merge({ isLoadingMenus: true }),
  [loadMenuTreeAction.FAILED]: state => state.merge({ isLoadingMenus: false }),
  [loadMenuTreeAction.DONE]: (state, menus) => state.merge({ isLoadingMenus: false, menus }),
  [updateMenuAction.INIT]: (state, { menuId, data }) => state.merge({ menus: updateMenus(state, [menuId], data) }),
  [updateMenusAction.INIT]: (state, { menuIds, data }) => state.merge({ menus: updateMenus(state, menuIds, data) }),
  [updateCategoryAction.INIT]: (state, { categoryId, data }) => state.merge({ menus: updateCategories(state, [categoryId], data) }),
  [updateCategoriesAction.INIT]: (state, { categoryIds, data }) => state.merge({ menus: updateCategories(state, categoryIds, data) }),
  [updateMenuEntryAction.INIT]: (state, { menuEntryId, data }) => state.merge({ menus: updateMenuEntries(state, [menuEntryId], data) }),
  [updateMenuEntriesAction.INIT]: (state, { menuEntryIds, data }) => state.merge({ menus: updateMenuEntries(state, menuEntryIds, data) }),
  [loadProductsAction.INIT]: state => state.merge({ isLoadingProducts: true }),
  [loadProductsAction.FAILED]: state => state.merge({ isLoadingProducts: false }),
  [loadProductsAction.DONE]: (state, products) => state.merge({ isLoadingProducts: false, products }),
  [updateProductAction.INIT]: (state, { productId, data }) => state.merge({ products: updateProducts(state, [productId], data) }),
  [updateProductsAction.INIT]: (state, { productIds, data }) => state.merge({ products: updateProducts(state, productIds, data) }),
  [loadProductionPlacesAction.INIT]: state => state.merge({ isLoadingProductionPlaces: true }),
  [loadProductionPlacesAction.FAILED]: state => state.merge({ isLoadingProductionPlaces: false }),
  [loadProductionPlacesAction.DONE]: (state, productionPlaces) => state.merge({ productionPlaces, isLoadingProductionPlaces: false }),
}, INITIAL_STATE);

export default reducers;
